import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SortList } from './sort-list/SortList';
import { SearchFacetTitle } from '../aside-filters/SearchFacetLib';

export const SearchSort: FC = () => {
  return (
    <div className="search-filter search-filters-sort-list">
      <SearchFacetTitle>
        <FormattedMessage id="search/components/search-sort/SearchSort.tsx/1" />
      </SearchFacetTitle>
      <SortList />
    </div>
  );
};
